import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import type { DirectionFindInterface } from '@zaoblako/shared/modules/catalog/dtos/direction/direction-find.dto';
import { DirectionService } from '@zaoblako/web/core/services/finance/direction.service';
import { TreeSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/tree-select/tree-select.component';

@Component({
  standalone: true,
  selector: 'crm-direction-single-select',
  templateUrl: './direction-single-select.component.html',
  imports: [CommonModule, TreeSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DirectionSingleSelectComponent implements OnChanges {
  @Input() public loading: boolean;
  @Input() public groupsOnly: boolean;
  @Input() public disabled: boolean;
  @Input() public groupsDisabled = false;
  @Input() public showClear = false;
  @Input() public scrollHeight = '300px';
  @Input() public class: string;
  @Input() public label: string;
  @Input() public styleClass: any;
  @Input() public appendTo: string;
  @Input() public sort = 'sortIndex:number';

  @Output() public selectedDirectionChange = new EventEmitter<DirectionFindInterface>();
  @Output() public panelShow = new EventEmitter<any>();
  @Output() public panelHide = new EventEmitter<any>();

  public _directions: DirectionFindInterface[] = [];
  public _selectedDirection: DirectionFindInterface;

  public filteredDirections: DirectionFindInterface[] = [];
  public selectedFilteredDirection: DirectionFindInterface;

  @Input()
  public set selectedDirection(direction: DirectionFindInterface) {
    this._selectedDirection = direction;
    this.setSelectedFilteredDirection();
  }

  @Input()
  public set directions(directions: DirectionFindInterface[]) {
    this._directions = directions;
    this.filteredDirections = this.getFilteredDirections();
    this.setSelectedFilteredDirection();
  }

  public constructor(private readonly directionService: DirectionService) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.groupsOnly?.currentValue) {
      this.filteredDirections = this.getFilteredDirections();
      this.setSelectedFilteredDirection();
    }
  }

  public selectDirectionsHandler(direction: DirectionFindInterface) {
    this.selectedDirectionChange.emit(direction);
  }

  private setSelectedFilteredDirection() {
    const selectedFilteredDirection = this.directionService
      .getLeafDirectionsWithParent(this.filteredDirections)
      .find((direction) => direction.id === this._selectedDirection?.id);
    if (selectedFilteredDirection) {
      this.selectedFilteredDirection = selectedFilteredDirection;
    }
  }

  private getFilteredDirections(directions: DirectionFindInterface[] = this._directions): DirectionFindInterface[] {
    let filteredDirections: DirectionFindInterface[] = [];

    if (this.groupsOnly) {
      directions.forEach((direction) => {
        if (direction?.group) {
          if (direction.children?.length) {
            direction.children = this.getFilteredDirections(direction.children);
          }
          filteredDirections.push(direction);
        }
      });
    } else {
      filteredDirections = directions;
    }
    return filteredDirections;
  }
}
